import { Box, IconButton, Modal, Typography } from '@mui/material';
import React from 'react';
import './DisputeResolveModal.css';
import closeIcon from '../../../../../assets/Admin/RequestImages/close-icon.svg';
import approveIcon from '../../../../../assets/Admin/RequestImages/approve-icon.svg';
import { toast } from 'react-hot-toast';
// import { useNavigate } from "react-router-dom";
// import { axiosInstance } from "../../../../../utils/tokenUtils";
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '30% !important',
  bgcolor: 'background.paper',
  boxShadow: 24,
};

const DisputeResolveModal = ({
  setResolveOpen,
  onResolve,
  userRole = 'student',
  isReport = false,
}) => {
  // const navigate = useNavigate();

  const handleClose = () => {
    setResolveOpen(false);
  };
  const handleResolve = async () => {
    try {
      await onResolve(''); // Passing empty string as comment
      toast.success(isReport ? 'Report approved successfully' : 'Dispute approved successfully');
      handleClose();
    } catch (error) {
      console.error(`Error approving ${isReport ? 'report' : 'dispute'}:`, error);
      toast.error(
        error.response?.data?.detail || `Failed to approve ${isReport ? 'report' : 'dispute'}`
      );
    }
  };

  // Content based on user role and type (report vs dispute)
  const getModalTitle = () => {
    if (isReport) {
      return userRole === 'teacher' ? 'Approve Instructor Report' : 'Approve Learner Report';
    }
    return userRole === 'teacher' ? 'Approve Instructor Dispute' : 'Approve Learner Dispute';
  };

  const getModalContent = () => {
    if (isReport) {
      if (userRole === 'teacher') {
        return "You are about to approve this report filed by the instructor. This means you've determined the instructor's claim is valid and requires action.";
      } else {
        return "You are about to approve this report filed by the learner. This means you've determined the learner's claim is valid and requires action.";
      }
    }
    if (userRole === 'teacher') {
      return "You are about to approve this dispute filed by the instructor. This means you've determined the instructor's claim is valid, and the learner's account will be temporarily restricted. The session will be marked as disputed.";
    } else {
      return "You are about to approve this dispute filed by the learner. This means you've determined the learner's claim is valid, and they will receive a refund for the session. The payment will be reversed from the instructor's account.";
    }
  };

  const getNoteText = () => {
    if (isReport) {
      return 'Note: Approving a report means you have reviewed the case and determined that the complaint is valid and requires action.';
    }
    return 'Note: Approving a dispute means you have reviewed the case and determined that the complaint is valid and requires action.';
  };

  const getButtonText = () => {
    return isReport ? 'Approve Report' : 'Approve Dispute';
  };

  return (
    <Modal
      open={true}
      // onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box
        sx={{
          ...style,
          width: '30%',
          maxHeight: '98vh',
          fontFamily: 'Poppins',
          borderRadius: '12px',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box className="flex items-center justify-between px-[5%] py-4 border-b border-[#D5DEE3]">
          <Typography className="resolve-application-text">{getModalTitle()}</Typography>
          <IconButton onClick={handleClose}>
            <img src={closeIcon} alt="close" />
          </IconButton>
        </Box>
        <Box className="flex flex-col items-center justify-center gap-4 px-6 py-4 border-b border-[#D5DEE3]">
          <img src={approveIcon} alt="approve" width="132.727px" height="70px" />
          <Typography className="resolve-application-text">{getModalContent()}</Typography>
          <Typography className="resolve-note-text">{getNoteText()}</Typography>
        </Box>
        <Box className="flex items-center justify-center gap-4 px-6 py-4">
          <button className="cancel-button" onClick={handleClose}>
            Cancel
          </button>
          <button className="resolve-application-button" onClick={handleResolve}>
            {getButtonText()}
          </button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DisputeResolveModal;
